import React from 'react';
import { Tag, Space, Button } from 'antd';
import { CloseOutlined, ClearOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { GET_GROUPS } from '../../mutations/groups';

const fieldLabels = {
  'reference': 'Código',
  'name': 'Nome',
  'brand': 'Marca',
  'description': 'Descrição',
  'group': 'Grupo',
  'hasImage': 'Tem Imagem',
  'hasPriceSegmentation': 'Tem Tabela de Preço',
  'hasInfos': 'Tem Informações Adicionais'
};

const operatorLabels = {
  'contains': 'contém',
  'not_contains': 'não contém',
  'equals': 'é exatamente',
  'is_empty': 'está em branco',
  'is_not_empty': 'está preenchido',
  'has': 'tem',
  'has_not': 'não tem'
};

const getFilterLabel = (filter, groups = []) => {
  const fieldLabel = fieldLabels[filter.field] || filter.field;
  const operatorLabel = operatorLabels[filter.operator] || filter.operator;
  
  // Para operadores que não precisam de valor
  if (['is_empty', 'is_not_empty', 'has', 'has_not'].includes(filter.operator)) {
    return `${fieldLabel} ${operatorLabel}`;
  }
  
  let valueText = '';
  
  if (filter.field === 'group') {
    if (Array.isArray(filter.value)) {
      // Buscar nomes dos grupos pelos IDs
      const selectedGroups = groups.filter(group => filter.value.includes(group.id));
      valueText = selectedGroups.map(group => group.name).join(', ');
    } else if (filter.value) {
      // Valor único - buscar o nome do grupo
      const group = groups.find(g => g.id === filter.value);
      valueText = group ? group.name : filter.value;
    }
  } else if (Array.isArray(filter.value)) {
    valueText = filter.value.join(', ');
  } else {
    valueText = filter.value?.toString() || '';
  }
  
  if (valueText.length > 30) {
    valueText = valueText.substring(0, 30) + '...';
  }
  
  return `${fieldLabel} ${operatorLabel} "${valueText}"`;
};

const ActiveAdvancedProductFilters = ({ filters, onRemoveFilter, onClearAll, style = {} }) => {
  // Buscar grupos para converter IDs em nomes
  const { data: groupsData } = useQuery(GET_GROUPS, {
    variables: { page: 1, perPage: 1000, search: '' },
    skip: !filters.some(f => f.field === 'group')
  });
  
  const groups = groupsData?.groups?.edges?.map(edge => edge.node) || [];

  if (!filters || filters.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: 16, ...style }}>
      <Space wrap size={[8, 8]}>
        <span style={{ fontWeight: 500, color: '#666' }}>Filtros avançados de produtos:</span>
        {filters.map((filter, index) => (
          <Tag
            key={`${filter.id}-${index}`}
            closable
            onClose={() => onRemoveFilter(index)}
            color="blue"
            style={{
              margin: '2px',
              padding: '4px 8px',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              maxWidth: '300px'
            }}
          >
            <span style={{ 
              overflow: 'hidden', 
              textOverflow: 'ellipsis', 
              whiteSpace: 'nowrap',
              fontSize: '12px'
            }}>
              {getFilterLabel(filter, groups)}
            </span>
          </Tag>
        ))}
        {filters.length > 1 && (
          <Button
            size="small"
            type="text"
            icon={<ClearOutlined />}
            onClick={onClearAll}
            style={{ 
              color: '#ff4d4f',
              fontSize: '12px',
              padding: '2px 6px',
              height: 'auto'
            }}
          >
            Limpar todos
          </Button>
        )}
      </Space>
    </div>
  );
};

export default ActiveAdvancedProductFilters; 